export const APP_ID = process.env.REACT_APP_ID!
export const APP_URL = process.env.REACT_APP_URL!
export const newArchBaseUrl = process.env.REACT_APP_NEW_ARCH_BASE_URL
export const hostName = process.env.REACT_APP_HOST_NAME
export const testHostName = process.env.REACT_APP_TEST_HOST_NAME
export const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID
export const microsoftClientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID
export const microsoftClientRedirectUri =
  process.env.REACT_APP_MICROSOFT_REDIRECT_URL
export const customizationSettingsBaserUrl = process.env.REACT_APP_EWA_BASE_URL
export const appColor = process.env.REACT_APP_APP_COLOR
export const smartTextBaseUrl = `https://padefiles.blob.core.windows.net/images/smarttext`
export const csvBulkUploadEmployeeSheetLicenceKey = process.env
  .REACT_APP_CSVBOX_SHEET_LICENSE_KEY as string
export const csvBulkUploadChangeSheetLicenceKey = process.env
  .REACT_APP_CSVBOX_BULK_CHANGE_SHEET_LICENSE_KEY as string
export const stagingUrl = "https://staging.paidhr.com"
export const devUrl = "https://white-stone-0f6021d10.2.azurestaticapps.net"
export const localUrl = "http://localhost:3001"
export const performanceVersion = "v2"
export const REACT_APP_GOOGLE_MAP_KEY =
  process.env.REACT_APP_GOOGLE_MAP_KEY ||
  "AIzaSyCbLrh77rEnDLhGru8gKWCHJTaDsiL4EfE"

// HandHold in-app guidance. The publishable `hh_pk_` key is safe in the
// bundle (like a Stripe publishable key); the widget is skipped entirely
// when either value is missing.
export const handholdApiKey = process.env.REACT_APP_HANDHOLD_API_KEY
export const handholdBaseUrl = process.env.REACT_APP_HANDHOLD_BASE_URL
